module.exports = __webpack_public_path__ + "static/media/clue-3.991142b6.svg";